import React, { FunctionComponent, ReactElement, memo } from 'react'
import FloatingText from '@sport1/react-elements/FloatingText'
import Grid from '@sport1/react-elements/Grid'
import BigButton from '../BaseComponents/Button/Standard/Big'
import { TestID } from '../utils/PropTypesDefinitions'
import VerticalSpacer from '../Layouts/Spacer/Vertical'

export type CookieBannerProps = {
    /** The text content of the banner. */
    text: string
    /** The hyperlink text at the end of the banner text. */
    hyperLinkText: string
    /** The text for the agree button. */
    buttonText: string
    /**
     * function which is triggered when the link at the end of the banner text is clicked.
     *
     * @TJS-type function
     *
     * */
    onTextPress?: () => void
    /**
     * use href instead
     *
     * @deprecated true
     * */
    onTextHref?: string
    /** href link for the button */
    href?: string
    /**
     * function which is triggered when button is pressed
     *
     * @TJS-type function
     * */
    onAgree: () => void
} & TestID

const CookieBanner: FunctionComponent<CookieBannerProps> = ({
    text,
    hyperLinkText,
    buttonText,
    onTextPress,
    onTextHref,
    href,
    onAgree,
    testID,
}): ReactElement => {
    return (
        <Grid noExpand paddingX={5} backgroundColor="pearl" testID={testID}>
            <Grid noExpand marginBottom={3}>
                <FloatingText
                    textObjects={[
                        {
                            content: text,
                            textStyle: {
                                fontSize: 15,
                                fontFamily: 'Sport1-Regular',
                                color: 'onyx',
                            },
                        },
                        {
                            content: hyperLinkText,
                            textStyle: {
                                fontSize: 15,
                                fontFamily: 'Sport1-Bold',
                                textDecorationLine: 'underline',
                                color: 'onyx',
                            },
                            onPress: onTextPress,
                            href: href || onTextHref,
                        },
                    ]}
                />
            </Grid>
            <VerticalSpacer space="small" backgroundColor="pearl" />
            <BigButton
                testID={`${testID}_button`}
                expand
                backgroundColor="onyx-3"
                onPress={onAgree}
            >
                {buttonText}
            </BigButton>
        </Grid>
    )
}

export default memo(CookieBanner)
